module.exports = __webpack_public_path__ + "img/img_engineering_img3.30ffecf4.png";